// Página do cliente (chamados): what the institution's customers read. White label: never "Aubaine" nor
// "plataforma"; the institution's name comes from its branding.
export default {
  title: 'Meus chamados',
  ticketTitle: 'Chamado',
  intro: 'Acompanhe os seus chamados, responda e aprove orçamentos.',
  introWith: 'Acompanhe os seus chamados com {company}, responda e aprove orçamentos.',
  loading: 'Carregando',
  failed: 'Não foi possível carregar. Tente de novo.',
  retry: 'Tentar de novo',
  signOut: 'Sair',
  back: 'Meus chamados',
  close: 'Fechar',
  cancel: 'Cancelar',
  send: 'Abrir chamado',
  team: 'Equipe',
  access: {
    title: 'Acesso aos seus chamados',
    intro: 'Informe o e-mail cadastrado na empresa. Enviaremos um link de acesso, sem senha.',
    email: 'E-mail',
    send: 'Enviar link',
    sent: 'Se {email} estiver cadastrado, o link chega em alguns minutos. Confira também a caixa de spam.',
    another: 'Usar outro e-mail',
    expired: 'O seu link de acesso não vale mais. Peça um novo abaixo.',
    failed: 'Não foi possível enviar agora. Tente de novo em instantes.',
  },
  filter: 'Mostrar',
  open: 'Em andamento',
  closed: 'Encerrados',
  emptyOpen: 'Nenhum chamado em andamento',
  emptyClosed: 'Nenhum chamado encerrado',
  waiting:
    'Nenhum chamado aguarda você | 1 chamado aguarda a sua resposta | {n} chamados aguardam a sua resposta',
  updatedAt: 'Atualizado em {date}',
  openedOn: 'Aberto em {date}',
  responsible: 'Atendimento: {name}',
  new: 'Novo chamado',
  newTitle: 'Novo chamado',
  created: 'Chamado {number} aberto.',
  company: 'Empresa',
  subject: 'Assunto',
  kind: 'Tipo',
  description: 'Descrição',
  descriptionHint: 'Conte o que aconteceu, onde e, se possível, como repetir.',
  drop: 'Anexar arquivos',
  dropHint: 'Até 8 MB cada.',
  tooLarge: 'Arquivo grande demais (limite de 8 MB): {names}',
  removeFile: 'Remover {name}',
  descriptionTitle: 'Descrição',
  notFound: 'Chamado não encontrado',
  replyLabel: 'Sua mensagem',
  sendReply: 'Enviar',
  replySent: 'Mensagem enviada.',
  reopens: 'Este chamado foi encerrado por falta de resposta. Ao responder, ele é reaberto.',
  closedHint: 'Este chamado foi encerrado. Se precisar de algo, abra um novo chamado.',
  quotes: 'Orçamentos',
  type: {
    bug: 'Problema',
    improvement: 'Melhoria',
    question: 'Dúvida',
    other: 'Outro',
  },
  status: {
    open: 'Aberto',
    in_progress: 'Em atendimento',
    waiting_customer: 'Aguardando sua resposta',
    waiting_cost_approval: 'Orçamento aguardando sua aprovação',
    cost_negotiation: 'Orçamento em negociação',
    resolved: 'Aguardando sua confirmação',
    closed: 'Concluído',
    closed_no_response: 'Encerrado sem resposta',
    cost_refused: 'Orçamento recusado',
    cancelled: 'Cancelado',
  },
  pending: {
    response: 'Aguarda a sua resposta',
    quote: 'Orçamento para aprovar',
    acceptance: 'Confirme a entrega',
  },
  response: {
    text: 'A equipe aguarda a sua resposta. Escreva abaixo.',
    due: 'A equipe aguarda a sua resposta até {date}. Sem resposta, o chamado é encerrado.',
  },
  quote: {
    title: 'Orçamento v{version} para aprovação',
    version: 'Orçamento v{version}',
    amount: 'Valor',
    delivery: 'Prazo',
    approve: 'Aprovar orçamento',
    refuse: 'Recusar',
    reason: 'Por que você recusa? Ajuda a equipe a propor outra opção.',
  },
  quoteStatus: {
    pending: 'Aguardando',
    approved: 'Aprovado',
    rejected: 'Recusado',
    withdrawn: 'Retirado',
  },
  acceptance: {
    title: 'Confira a entrega',
    text: 'A equipe concluiu este chamado. Está tudo certo?',
    due: 'Sem retorno até {date}, a entrega é considerada aceita.',
    accept: 'Está tudo certo',
    missing: 'Falta algo',
    reason: 'O que falta ou não está certo?',
    send: 'Enviar',
  },
  decided: {
    quote: { yes: 'Orçamento aprovado.', no: 'Recusa enviada à equipe.' },
    acceptance: { yes: 'Entrega confirmada. Obrigado.', no: 'Enviado à equipe.' },
  },
  history: {
    title: 'Conversa',
    empty: 'Ainda não há mensagens.',
    created: 'abriu o chamado',
    comment: 'escreveu',
    response_requested: 'pediu uma informação',
    customer_replied: 'respondeu',
    recorded: 'registrou a sua resposta',
    quote_sent: 'enviou o orçamento v{version}',
    quote_decided: { approved: 'aprovou o orçamento', rejected: 'recusou o orçamento' },
    acceptance_requested: 'concluiu o chamado e pediu a sua confirmação',
    acceptance_decided: { accepted: 'confirmou a entrega', rejected: 'apontou o que falta' },
    reminder_sent: 'enviou um lembrete',
    auto_closed: 'encerrou o chamado por falta de resposta',
    auto_accepted: 'considerou a entrega aceita por falta de retorno',
  },
}
